<template>
  <div
    class="text-center button-show-correct-option"
  >
    <button class="btn btn-dark btn-sm" @click="hideCorrectOption">
      <span v-if="slideActive.showCorrectOption">Hide</span>
      <span v-if="!slideActive.showCorrectOption">Show</span>
      correct answer
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    hideCorrectOption() {
      this.updateSlideActiveAction({
        showCorrectOption: !this.slideActive.showCorrectOption,
      })
      this.$emit('updateSlide', {
        accessCode: this.presentation.uniqueAccessCode,
        showCorrectOption: this.slideActive.showCorrectOption,
      }, 2)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.button-show-correct-option {
  .btn {
    box-shadow: none;
    background-color: $primary-color;
    border: none;
    color: #fff;

    &:hover,
    &:active {
      background-color: $primary-hover-color;
    }
  }
}
</style>
